import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { AdminDownloadService } from '../../../services/admin-download.service';
import { FileType } from 'src/app/models/file-type';
import { LifeCycle } from 'src/app/models/lifecycle.model';
import { DocFile } from '../../../models/doc-file.model';
import { DocInfo } from '../../../models/doc-info.model';

@Component({
    selector: 'lex-admin-download',
    styleUrls: ['./admin-download.component.scss'],
    templateUrl: './admin-download.component.html',
    standalone: false
})
export class AdminDownloadComponent implements OnInit {
  checkedFileIndices: boolean[];
  docId = '';
  FileType = FileType;
  LifeCycle = LifeCycle;
  docFiles: DocFile[];
  docFilesDataSource: MatTableDataSource<DocFile>;
  docInfoDisplayedColumns = ['id', 'name'];
  fileInfoDisplayedColumns = ['selectFile', 'id', 'fileType', 'lifecycle'];
  docIdForm = null;
  docDetails: TitleValue[] = [];

  constructor(private adminDownloadService: AdminDownloadService, private errorBar: MatSnackBar, private formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.docIdForm = this.formBuilder.group({
      docId: [this.docId]
    });
  }

  onPaste(event: ClipboardEvent) {
    this.getDocInfo(event.clipboardData.getData('text/plain'));
  }

  getDocInfo(docId: string): void {
    this.docId = docId;
    this.docFiles = null;
    this.docFilesDataSource = null;
    this.checkedFileIndices = null;
    this.docDetails = [];

    this.adminDownloadService.getDocInfo(this.docId)
      .subscribe(
        docInfo => {
          this.setDocDetails(docInfo);

          this.docFiles = docInfo.docFiles;
          this.docFilesDataSource = new MatTableDataSource<DocFile>(this.docFiles);
          this.checkedFileIndices = new Array<boolean>(this.docFiles.length);
        },
        err => {
          console.log(err);
          if (err.status == "404")
            this.openErrorBar("The document, its case or its account was not found.");
          else
            this.openErrorBar("A server error occurred.");
        });
  }

  noFilesChecked(): boolean {
    if (this.docFiles == null) return true;
    return !this.docFiles.some((val, ind) => this.isFileChecked(val, ind));
  }

  checkAll(state: boolean) {
    for (let index = 0; index < this.checkedFileIndices.length; index++) this.checkedFileIndices[index] = state;
  }

  checkLifecycle(lifecycle: number) {
    for (let index = 0; index < this.checkedFileIndices.length; index++) {
      this.checkedFileIndices[index] = this.docFiles[index].lifecycle === lifecycle;
    }
  }

  checkOriginals() {
    for (let index = 0; index < this.checkedFileIndices.length; index++) {
      this.checkedFileIndices[index] = this.docFiles[index].fileType === FileType.OriginalFile;
    }
  }

  postFileList() {
    const fileIds = this.docFiles
      .filter((val, ind) => this.isFileChecked(val, ind))
      .map(f => f.fileId);

    this.adminDownloadService.postFileList(fileIds).subscribe();
  }

  private setDocDetails(docInfo: DocInfo): void {
    this.docDetails.push(new TitleValue('Account ID', docInfo.accountId));
    this.docDetails.push(new TitleValue('Account Name', docInfo.accountName));
    this.docDetails.push(new TitleValue('Case ID', docInfo.caseId));
    this.docDetails.push(new TitleValue('Case Name', docInfo.caseName));
    this.docDetails.push(new TitleValue('Document ID', docInfo.docId));
    this.docDetails.push(new TitleValue('Document Name', docInfo.docTitle));
  }

  private openErrorBar(message: string): void {
    this.errorBar.open(message, '', {
      duration: 3000
    });
  }

  private isFileChecked(value: DocFile, index: number): boolean {
    return this.checkedFileIndices[index] === true;
  }
}

class TitleValue {
  constructor(public title: string, public value: string) { }
}
